import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { formValueSelector } from 'redux-form';
import { toastr } from 'react-redux-toastr';
import { Row, Col } from 'reactstrap';
import { changeStepBookingOnRoute } from '../../../actions';
import { CIVA_SALES_ON_ROUTE_BOOKING_STEPS } from '../../../config/constants';
import Badge from '../../common/Badge';

const CONFIRMATION_STEP_INDEX = 3;

const RideBookingNavbar = ({
  currentStep,
  dispatchChangeStepBookingOnRoute,
  hasPinpadCharge,
}) => {
  const handleClick = (step) => {
    if (hasPinpadCharge) {
      toastr.warning(
        'Advertencia',
        'Hay un cobro aprobado en el pinpad. Anúlelo con "Cancelar pago" antes de volver a un paso anterior.',
      );
      return;
    }
    dispatchChangeStepBookingOnRoute(step);
  };

  const renderSteps = () => {
    const steps = CIVA_SALES_ON_ROUTE_BOOKING_STEPS;

    return steps.map((step, index) => {
      // current step is highlighted
      if (index === currentStep)
        return (
          <Col key={step.path}>
            <Badge color="info" text={index + 1} />
            &nbsp;{step.title}
          </Col>
        );
      // future steps are disabled and not clickable
      if (index > currentStep || currentStep === CONFIRMATION_STEP_INDEX)
        return (
          <Col key={step.path}>
            <Badge color="light" text={index + 1} />
            &nbsp;{step.title}
          </Col>
        );
      // past steps are clickable
      return (
        <Col
          key={step.path}
          onClick={() => {
            handleClick(step);
          }}
          className="clickable"
        >
          <Badge color="success" text={index + 1} />
          &nbsp;{step.title}
        </Col>
      );
    });
  };

  return (
    <div className="p-2 text-center">
      <Row>{renderSteps()}</Row>
    </div>
  );
};

RideBookingNavbar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  dispatchChangeStepBookingOnRoute: PropTypes.func.isRequired,
  hasPinpadCharge: PropTypes.bool.isRequired,
};

const selector = formValueSelector('rideBookingPassengerForm');

const mapStateToProps = (state) => ({
  hasPinpadCharge: (selector(state, 'transactionList') || []).some(
    (row) => row && row.pinpadPaid,
  ),
});

const mapDispatchToProps = {
  dispatchChangeStepBookingOnRoute: changeStepBookingOnRoute,
};

export default connect(mapStateToProps, mapDispatchToProps)(RideBookingNavbar);
